import { Inject, ModelEvents } from '@denishussar/html5-game-engine';
import { ModalsNames } from "../../Common/MadalsManager/ModalsList";
import { LocalizationContents } from "../../LocalizationContents";
import { CrazyGamesAdsLogic } from "../../Logic/CrazyGames/CrazyGamesAdsLogic";
import { GameLogic } from "../../Logic/GameLogic";
import { BoosterTypeEnum, GameModel, GameStateEnum } from '../../Models/GameModel';
import { AnalyticsController } from "../../Services/Analytics/AnalyticsController";
import { ConfirmationsYouRewardType } from "../Modals/Confirmations/ConfirmationsYouRewardController";
import { IWinScreenControllerOptions, WinScreenController } from "./WinScreenController";
import {AdsLogic} from "../../Logic/Ads/AdsLogic";

export class FTUEWinScreenController extends WinScreenController {
    public constructor(
        @Inject protected options: IWinScreenControllerOptions,
        @Inject protected gameLogic: GameLogic,
        @Inject protected adsLogic: AdsLogic,
        @Inject protected modelEvents: ModelEvents,
        @Inject protected model: GameModel,
    ) {
        super(options, gameLogic, adsLogic, modelEvents, model);
    }

    protected onInitialize() {
        super.onInitialize();

        const btn_share = this.$childControllers.get('btn_share');
        btn_share.visible = false;

        this.getDisplayObjectByQuery('container.coins_win')[0].visible = false;
        this.getDisplayObjectByQuery('container.needle_win')[0].visible = true;
    }

    protected onResize(width: number, height: number, scale: number) {
        super.onResize(width, height, scale);

        const btn_continue = this.$childControllers.get('btn_continue');
        btn_continue.display.position.set(0, btn_continue.display.position.y);
    }

    protected handleButtonNextClick(): void {
        const reward = 1;
        const onClose = () => {
            this.gameLogic.modalsManager.hide();
            this.gameLogic.addBooster(BoosterTypeEnum.needle, 1);
            this.gameLogic.setState(GameStateEnum.main);

            /*
            this.analytics.sendEvent(AnalyticsEventEnum.exitEndscreen, {
                picture_id: this.$model.picture.id,
                user_id: this.$model.userModel.id,
                method_id: 'coins',
            });
             */
        };

        this.gameLogic.modalsManager.show(ModalsNames.youReward, {
            type: ConfirmationsYouRewardType.needle,
            value: reward,
            text: LocalizationContents.getText('Your Reward'),
            okText: LocalizationContents.getText('Thanks'),
            okClick: () => onClose(),
            exitClick: () => onClose(),
        });
    }
}
